import _ from 'underscore';
import { StorageKey } from '../constants';

export const getImportRecommendationStorage = ({ userName, storageApi }) => {
  //
  function getDataForUser() {
    const data = storageApi.get(StorageKey) || {};
    const curUserData = data[userName] || {};
    return curUserData;
  }

  function setDataForUser(userData) {
    const data = storageApi.get(StorageKey) || {};
    data[userName] = userData;
    storageApi.set(StorageKey, data);
  }

  //
  const updateLastAdoptionTime = (recommendationId, timestamp, timestampStr) => {
    const now = new Date();
    const curUserData = getDataForUser();
    setDataForUser({
      ...curUserData,
      lastAdoptionTime: {
        timestamp: timestamp || now.getTime(),
        timestampStr: timestampStr || now.toUTCString(),
        recommendationId,
      },
    });
  };

  const removeLastAdoptionTime = () => {
    const curUserData = getDataForUser();
    delete curUserData.lastAdoptionTime;
    setDataForUser(curUserData);
  };

  const addUnsentAction = ({ recommendationId, status }) => {
    const now = new Date();
    const curUserData = getDataForUser();
    const unsentActions = curUserData.unsentActions || [];
    const latestAction = _.last(unsentActions);
    if (!latestAction
      || latestAction.recommendationId !== recommendationId
      || latestAction.status !== status) {
      // ignore same actions
      unsentActions.push({
        recommendationId,
        status,
        timestamp: now.getTime(),
        timestampStr: now.toUTCString(),
      });
    }
    setDataForUser({
      ...curUserData,
      unsentActions,
    });
  };

  const removeUnsentAction = (action) => {
    const curUserData = getDataForUser();
    const unsentActions = curUserData.unsentActions || [];
    setDataForUser({
      ...curUserData,
      unsentActions: _.reject(
        unsentActions,
        a => action === a || (a.recommendationId === action.recommendationId
          && a.timestamp === action.timestamp)
      ),
    });
  };

  return {
    updateLastAdoptionTime,
    removeLastAdoptionTime,
    get lastAdoptionTime() {
      const data = storageApi.get(StorageKey) || {};
      const curUserData = data[userName] || {};
      return curUserData.lastAdoptionTime;
    },
    //
    addUnsentAction,
    removeUnsentAction,
    get unsentActions() {
      const data = storageApi.get(StorageKey) || {};
      const curUserData = data[userName] || {};
      return curUserData.unsentActions;
    },
  };
};
